import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

// Material Dashboard Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LogoutButton from "layouts/logout";

// API
import api from "core/interceptors/api";

function StockHistory() {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchStockHistory = async () => {
    setLoading(true);
    try {
      const res = await api.get("/product/stock_history");
      if (res.data.status) {
        setHistory(res.data.stock_history || []);
      } else {
        Swal.fire("Error", "Failed to fetch stock history.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong while loading history.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStockHistory();
  }, []);

  const columns = [
    { Header: "S.No.", accessor: "s_no", width: "5%" },
    { Header: "Product Name", accessor: "product_name" },
    { Header: "Old Quantity", accessor: "old_quantity" },
    { Header: "New Quantity", accessor: "new_quantity" },
    { Header: "Updated By", accessor: "updated_by" },
    { Header: "Reason", accessor: "update_reason" },
    { Header: "Updated Date", accessor: "updated_at" },
  ];

  const data = history.map((item, index) => ({
    s_no: index + 1,
    product_name: item.product_name || "N/A",
    old_quantity: item.old_quantity ?? "N/A",
    new_quantity: item.new_quantity ?? "N/A",
    updated_by: item.updated_by || "System",
    update_reason: item.update_reason || "N/A",
    updated_at: item.updated_at || "N/A",
  }));

  return (
    <DashboardLayout>
      <MDBox display="flex" justifyContent="flex-end" alignItems="center">
        <LogoutButton onLogout={() => navigate("/login")} />
      </MDBox>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
              >
                <MDTypography variant="h6" color="white">
                  Product Stock Update History
                </MDTypography>
              </MDBox>

              <MDBox p={3}>
                {loading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="50vh"
                  >
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows: data }}
                    isSorted
                    entriesPerPage={{
                      defaultValue: rowsPerPage,
                      entries: [5, 10, 15, 20, 25],
                    }}
                    showTotalEntries
                    canSearch
                    pagination={{
                      variant: "contained",
                      color: "dark",
                      page,
                      onPageChange: (_, newPage) => setPage(newPage),
                      rowsPerPage,
                      onRowsPerPageChange: (_, newRows) => setRowsPerPage(newRows),
                      count: history.length,
                    }}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default StockHistory;
